import backgroundVideo from "../../assets/images/New folder/benefit_background.png";

const AutoPlayVideoWithSound = () => {
  return (
    <div className="relative w-full h-[414px] md:h-[300px] overflow-hidden bg-black z-0">
      <img
        src={backgroundVideo}
        className="w-full h-full object-cover"
        // Ensure browsers don't pause it when moving away if possible
      />
    </div>
  );
};

export default AutoPlayVideoWithSound;
